/** @format */
import _LandingPage from './LandingPage';
import _GlobalAmbasador from './GlobalAmbasador';

export const LandingPage = _LandingPage;
export const GlobalAmbasador = _GlobalAmbasador;
